(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clipher-cart"] && !Shopify.designMode) return;
  try {
    
const cpCartRoot = () => window.Shopify?.routes?.root || '/';

const cpUpdateCartLine = async (input, quantity) => {
  if (!input || input.dataset.cpUpdating === 'true') return;
  const parsedQuantity = Number.parseInt(quantity, 10);
  if (!Number.isFinite(parsedQuantity) || parsedQuantity < 0) {
    input.value = input.defaultValue;
    return;
  }
  const previousValue = input.defaultValue;
  const item = input.closest('[data-cp-cart-item]');
  const status = item?.querySelector('[data-cp-cart-updating]');
  input.value = parsedQuantity;
  input.dataset.cpUpdating = 'true';
  input.disabled = true;
  item?.classList.add('is-updating');
  if (status) status.hidden = false;
  try {
    const response = await fetch(`${cpCartRoot()}cart/change.js`, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: input.dataset.cartKey, quantity: parsedQuantity})
    });
    if (!response.ok) throw new Error('change_failed');
    window.location.reload();
  } catch (error) {
    input.value = previousValue;
    input.disabled = false;
    delete input.dataset.cpUpdating;
    item?.classList.remove('is-updating');
    if (status) { status.hidden = false; status.textContent = 'No se pudo actualizar. Intenta de nuevo.'; }
  }
};

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-cp-cart-qty-input]');
  if (!input) return;
  cpUpdateCartLine(input, input.value);
});

document.addEventListener('click', async (event) => {
  const quantityButton = event.target.closest('[data-cp-cart-qty-change]');
  if (quantityButton) {
    const item = quantityButton.closest('[data-cp-cart-item]');
    const input = item?.querySelector('[data-cp-cart-qty-input]');
    if (!input) return;
    const current = Number.parseInt(input.value, 10) || 0;
    const delta = Number.parseInt(quantityButton.dataset.cpCartQtyChange, 10) || 0;
    cpUpdateCartLine(input, Math.max(0, current + delta));
    return;
  }

  const button = event.target.closest('[data-cp-upsell-add]');
  if (!button) return;
  const card = button.closest('.cp-cart-upsell-card');
  const selector = card?.querySelector('[data-cp-upsell-variant]');
  const variantId = selector?.value || button.dataset.variantId;
  if (!variantId) return;
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Agregando…';
  try {
    const response = await fetch(`${cpCartRoot()}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
    });
    if (!response.ok) throw new Error('add_failed');
    button.textContent = 'Agregado';
    window.location.reload();
  } catch (error) {
    button.disabled = false;
    button.textContent = originalLabel;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clipher-products-quick"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cp-quick-add]');
  if (!button) return;
  const card = button.closest('.cp-quick-product-card');
  const selector = card?.querySelector('[data-cp-quick-variant]');
  const variantId = selector?.value || button.dataset.variantId;
  if (!variantId) return;
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Agregando…';
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
    });
    if (!response.ok) throw new Error('add_failed');
    button.textContent = 'Agregado ✓';
    const cartLink = card?.querySelector('[data-cp-quick-cart-after]');
    if (cartLink) cartLink.hidden = false;
    window.setTimeout(() => { button.disabled = false; button.textContent = 'Agregar otro'; }, 650);
  } catch (error) {
    button.disabled = false;
    button.textContent = original;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
